import _toConsumableArray from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _createForOfIteratorHelper from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { computed, defineComponent, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import i18n from "@/lang";
import { ModalComponents, ModalStatus } from "@/constants/modal";
import { dialogVisibleForStatus, hideDialog } from "@/utils/vue-helpers/modal";
import { groupedPSS } from "@/utils/vue-helpers/booking";
import { BookingStatus, PSSType } from "@/types/db/product-slot-state";
import { processPromocode } from "@/utils/vue-helpers/promocode";
import BookingModule from "@/store/modules/booking";
import { AccountingState, TransactionTypes } from "@/types/db/accounting";
import NotificationService from "@/services/notification.service";
import { formatDateTime } from "@/utils/helpers/dates";
import { getPSSValue } from "@/utils/helpers/product-slot-state";
import { sumArray } from "@/utils/helpers/common";
import CouponIcon from "@/assets/images/svg/coupon.svg";
export default defineComponent({
  name: ModalComponents.PromocodeCampaignsTickets,
  props: {
    modalProps: {
      type: Object,
      required: true
    }
  },
  setup: function setup(props) {
    var _useI18n = useI18n(),
        t = _useI18n.t;

    var modalVisibility = dialogVisibleForStatus(ModalStatus.PromocodeCampaignsTickets);
    var searchQuery = ref("");
    var isapplyToAllLoading = ref(false);
    var isapplyToSomeLoading = ref(false);
    var pssCount = ref({});
    var promocodeData = computed(function () {
      return props.modalProps.props;
    });
    var groupedPSSList = computed(function () {
      var _BookingModule$select;

      var gr = groupedPSS(((_BookingModule$select = BookingModule.selectedBooking) === null || _BookingModule$select === void 0 ? void 0 : _BookingModule$select.pssList) || []); // exclude confirmed, canceled and abandoned pss
      // assign an id to each pss group to track quantities later

      return gr.filter(function (pss) {
        return ![BookingStatus.Confirmed || BookingStatus.Abandoned || BookingStatus.Canceled].includes(pss.bookingStatus) && (!searchQuery.value || pss.categoryName.toLowerCase().includes(searchQuery.value.toLowerCase()) || pss.priceName.toLowerCase().includes(searchQuery.value.toLowerCase()));
      }).map(function (pss, index) {
        return _objectSpread(_objectSpread({}, pss), {}, {
          index: index
        });
      });
    });

    function incrementPssCount(index) {
      pssCount.value[index]++;
    }

    function decrementPssCount(index) {
      if (pssCount.value[index] === 0) {
        return;
      }

      pssCount.value[index]--;
    }

    function setPssCount(index, qty) {
      pssCount.value[index] = qty;
    }

    function applyToSelectedTickets() {
      return _applyToSelectedTickets.apply(this, arguments);
    }

    function _applyToSelectedTickets() {
      _applyToSelectedTickets = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _BookingModule$select5;

        var pssList, pssListToApplyCodeOn, hasTicketsSelected, _loop2, groupedPssIndex, _ret;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (promocodeData.value) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                pssList = (_BookingModule$select5 = BookingModule.selectedBooking) === null || _BookingModule$select5 === void 0 ? void 0 : _BookingModule$select5.pssList;

                if (pssList) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return");

              case 5:
                isapplyToSomeLoading.value = true;
                pssListToApplyCodeOn = [];
                hasTicketsSelected = false;

                _loop2 = function _loop2(groupedPssIndex) {
                  var _groupedPSSList$value;

                  var numTickets = pssCount.value[groupedPssIndex];

                  if (numTickets === 0) {
                    return "continue";
                  }

                  hasTicketsSelected = true; // get pss uuids to apply code on

                  var pssUuids = (_groupedPSSList$value = groupedPSSList.value.find(function (groupedPSS) {
                    return groupedPSS.index === Number(groupedPssIndex);
                  })) === null || _groupedPSSList$value === void 0 ? void 0 : _groupedPSSList$value.pssIds;
                  if (!pssUuids) return "continue";
                  var filteredPss = pssList.filter(function (pss) {
                    return pssUuids.includes(String(pss.uuid));
                  });
                  pssListToApplyCodeOn.push.apply(pssListToApplyCodeOn, _toConsumableArray(filteredPss.slice(0, numTickets)));
                };

                _context.t0 = regeneratorRuntime.keys(pssCount.value);

              case 10:
                if ((_context.t1 = _context.t0()).done) {
                  _context.next = 17;
                  break;
                }

                groupedPssIndex = _context.t1.value;
                _ret = _loop2(groupedPssIndex);

                if (!(_ret === "continue")) {
                  _context.next = 15;
                  break;
                }

                return _context.abrupt("continue", 10);

              case 15:
                _context.next = 10;
                break;

              case 17:
                if (hasTicketsSelected) {
                  _context.next = 21;
                  break;
                }

                NotificationService.showCustomInfoWithTitle(i18n.global.t("promo-campaigns.select-item-to-apply"), "Info");
                isapplyToSomeLoading.value = false;
                return _context.abrupt("return");

              case 21:
                _context.next = 23;
                return processPromocode(promocodeData.value.code, pssListToApplyCodeOn);

              case 23:
                isapplyToSomeLoading.value = false;
                hideDialog();

              case 25:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _applyToSelectedTickets.apply(this, arguments);
    }

    function applyToAllTickets() {
      return _applyToAllTickets.apply(this, arguments);
    }

    function _applyToAllTickets() {
      _applyToAllTickets = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (promocodeData.value) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                isapplyToAllLoading.value = true;
                _context2.next = 5;
                return processPromocode(promocodeData.value.code);

              case 5:
                isapplyToAllLoading.value = false;
                hideDialog();

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _applyToAllTickets.apply(this, arguments);
    }

    onMounted(function () {
      var _BookingModule$select2, _BookingModule$select3;

      var pssList = (_BookingModule$select2 = BookingModule.selectedBooking) === null || _BookingModule$select2 === void 0 ? void 0 : _BookingModule$select2.pssList;
      var accountings = (_BookingModule$select3 = BookingModule.selectedBooking) === null || _BookingModule$select3 === void 0 ? void 0 : _BookingModule$select3.accountings;

      if (!pssList || !accountings) {
        return;
      }

      var _iterator = _createForOfIteratorHelper(groupedPSSList.value),
          _step;

      try {
        var _loop = function _loop() {
          var groupedPss = _step.value;
          var ticketsWithPromocodeApplied = pssList.filter(function (pssInBooking) {
            return pssInBooking.uuid && groupedPss.pssIds.includes(pssInBooking.uuid) && accountings.find(function (acc) {
              var _promocodeData$value;

              return acc.promocode && acc.promocode === ((_promocodeData$value = promocodeData.value) === null || _promocodeData$value === void 0 ? void 0 : _promocodeData$value.code) && acc.refund !== 1 && acc.transactionType === TransactionTypes.TRANSACTION_TYPE_DISCOUNT && (acc.state === AccountingState.Completed || acc.state === AccountingState.Pending) && acc.accountingEntriesList.some(function (ae) {
                return ae.productSlotStateUuid === pssInBooking.uuid;
              });
            });
          });
          pssCount.value[groupedPss.index] = ticketsWithPromocodeApplied.length;
        };

        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    });

    function getTicketAppliedDiscountCodes(pssGroup) {
      var _BookingModule$select4;

      var promocodeAccountings = (_BookingModule$select4 = BookingModule.selectedBooking) === null || _BookingModule$select4 === void 0 ? void 0 : _BookingModule$select4.accountings.filter(function (acc) {
        return acc.promoCodeId && acc.refund !== 1 && acc.transactionType === TransactionTypes.TRANSACTION_TYPE_DISCOUNT && (acc.state === AccountingState.Completed || acc.state === AccountingState.Pending);
      });

      if (!promocodeAccountings || !promocodeAccountings.length) {
        // there are no promocode discount accountings
        return [];
      }

      var rowPssListUuids = pssGroup.pssIds;
      var pssGroupPricesSum = pssGroup.quantity * getPSSValue(pssGroup);
      var lines = [];

      var _iterator2 = _createForOfIteratorHelper(promocodeAccountings),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var acc = _step2.value;
          var promocodeAEs = acc.accountingEntriesList.filter(function (ae) {
            return rowPssListUuids.some(function (element) {
              return element === ae.productSlotStateUuid && ae.value > 0;
            });
          });
          if (!promocodeAEs || !promocodeAEs.length) continue;
          var pssGroupDiscountsSum = sumArray(promocodeAEs.map(function (it) {
            return it.value;
          }));
          var newPriceSum = pssGroupPricesSum - pssGroupDiscountsSum;
          var percentage = ((pssGroupPricesSum - newPriceSum) / pssGroupPricesSum * 100).toFixed(0);
          var line = {
            code: String(acc.promocode),
            percentage: percentage
          };
          lines.push(line);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return lines;
    }

    return {
      t: t,
      modalVisibility: modalVisibility,
      searchQuery: searchQuery,
      isapplyToAllLoading: isapplyToAllLoading,
      isapplyToSomeLoading: isapplyToSomeLoading,
      hideDialog: hideDialog,
      groupedPSSList: groupedPSSList,
      pssCount: pssCount,
      incrementPssCount: incrementPssCount,
      decrementPssCount: decrementPssCount,
      setPssCount: setPssCount,
      applyToSelectedTickets: applyToSelectedTickets,
      applyToAllTickets: applyToAllTickets,
      promocodeData: promocodeData,
      formatDateTime: formatDateTime,
      PSSType: PSSType,
      getTicketAppliedDiscountCodes: getTicketAppliedDiscountCodes,
      CouponIcon: CouponIcon
    };
  }
});